import { render, staticRenderFns } from "./QuizBanner.vue?vue&type=template&id=08906a30&scoped=true&"
import script from "./QuizBanner.vue?vue&type=script&lang=js&"
export * from "./QuizBanner.vue?vue&type=script&lang=js&"
import style0 from "./QuizBanner.vue?vue&type=style&index=0&id=08906a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08906a30",
  null
  
)

export default component.exports